module.exports = __webpack_public_path__ + "img/党史学习教育-块面点击-迅捷压缩.086fe21d.png";